import { render, staticRenderFns } from "./ProjectsIcon.vue?vue&type=template&id=4937ad04"
import script from "./ProjectsIcon.vue?vue&type=script&lang=js"
export * from "./ProjectsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports